import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-roster-toolbar',
  templateUrl: './roster-toolbar.component.html',
  styleUrls: ['./roster-toolbar.component.scss']
})
export class RosterToolbarComponent {

  @Input() gridHirView: string = 'grid';
  @Input() teamSrchName: string;
  @Input() totalTeams: number;
  @Input() rosterName: string;
  @Input() memViewTeam: any;
  @Input() selectedGroupProfileTeamsArr: any[] = [];
  @Input() slectedIndividualTeamArr: any[] = [];
  @Input() mockupReportArgs: any;
  @Input() mockupReportArgsArr: any[] = [];
  @Input() openPdfPopup: boolean = false;
  @Input() teamSrchBy: string = 'name';

  @Output() viewChange = new EventEmitter<string>();
  @Output() searchTeam = new EventEmitter<any>();
  @Output() cancelSearch = new EventEmitter<void>();
  @Output() newTeam = new EventEmitter<void>();
  @Output() teamSrchNameChange = new EventEmitter<string>();
  @Output() searchMembers = new EventEmitter<any>();
  @Output() cancelSrchTeamMember = new EventEmitter<void>();
  @Output() hierarchicalView = new EventEmitter<void>();
  @Output() accordToggle = new EventEmitter<MouseEvent>();
  @Output() updateFilter = new EventEmitter<any>();
  @Output() searchRoasterReset = new EventEmitter<void>();
  @Output() openPdfPopupChange = new EventEmitter<boolean>();
  @Output() mockupReportArgsChange = new EventEmitter<any>();
  @Output() deleteSelectedTeams = new EventEmitter<void>();
  @Output() downloadCsv = new EventEmitter<string>();

  onViewChange(view: string): void {
    this.viewChange.emit(view);
  }

  onSearchKeyup(event: any): void {
    this.teamSrchNameChange.emit(this.teamSrchName);
    if (this.gridHirView === 'memView') {
      this.searchMembers.emit(event);
    } else {
      this.searchTeam.emit(event);
    }
  }

  onCancelSearch(): void {
    if (this.gridHirView === 'memView') {
      this.cancelSrchTeamMember.emit();
    } else {
      this.cancelSearch.emit();
    }
  }

  onNewTeam(): void {
    this.newTeam.emit();
  }

  onHierarchicalView(): void {
    this.hierarchicalView.emit();
  }

  onAccordToggle(event: MouseEvent): void {
    this.accordToggle.emit(event);
  }

  onUpdateFilter(event: any): void {
    this.updateFilter.emit(event);
  }

  onSearchRoasterReset(): void {
    this.searchRoasterReset.emit();
  }

  onDeleteSelectedTeams(): void {
    this.deleteSelectedTeams.emit();
  }

}
